<template>
  <div style="width: 100%; height: 100%">
    <!-- <pdf ref="pdf" v-for="i in numPages" :key="i" :src="url" :page="i"> </pdf> -->
    <iframe style="width: 100%; height: 100%" :src="url">
      此浏览器不支持该用户手册格式。请下载以查看：
      <a :href="url">下载用户手册</a>
    </iframe>
    <!-- <embed
      style="width: 100%; height: 100%"
      :src="url"
      type="application/pdf"
    /> -->
    <!-- <object
      :data="url"
      style="width: 100%; height: 100%"
      type="application/pdf"
    ></object> -->
  </div>
</template>
<script>
// import pdf from 'vue-pdf'
export default {
  //   components: {
  //     pdf
  //   },
  data () {
    return {
      url: process.env.BASE_URL + 'pdf/用户手册.pdf',
      numPages: null // pdf 总页数
    }
  },
  mounted () {
    // this.getNumPages()
  },
  methods: {
    // // 计算pdf页码总数
    // getNumPages () {
    //   const loadingTask = pdf.createLoadingTask(this.url)
    //   loadingTask.promise.then(pdf => {
    //     this.numPages = pdf.numPages
    //   }).catch(err => {
    //     console.error('pdf 加载失败', err)
    //   })
    // }
  }
}
</script>
